import request from "./request";
import axios from "axios";

/*
curl -X POST \
  https://devapi.primestreet.io/auth/oauth2.0/accessToken \
  -H 'Content-Type: application/x-www-form-urlencoded' \
  -H 'Postman-Token: 5ccd21b5-36ab-4d0c-bfc9-97281b8fe7c5' \
  -H 'cache-control: no-cache' \
  -H 'content-type: multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW' \
  -F grant_type=refresh_token \
  -F client_id=oauthclient \
  -F client_secret=secret \
  -F refresh_token=RT-5-QEp3WxlssMpMzulsCvmPr43NKBWBWVcL
 */
const auth = {
  service() {
    return {
      login(username, password, clientId) {
        let headers = request.headers(false, false);
        headers["Content-Type"] = "application/x-www-form-urlencoded";

        let data = new FormData();
        data.append("grant_type", "password");
        data.append("client_id", clientId);
        data.append("username", username);
        data.append("password", password);

        return axios({
          method: "POST",
          url: process.env.VUE_APP_API + "/auth/oauth2.0/accessToken",
          data: data,
          headers: headers,
        });
      },
      loginWithCode(code, codeVerifier) {
        console.log("Here on auth with loginWithCode");
        console.log(process.env.VUE_APP_API);

        let headers = request.headers(false, false);
        headers["Content-Type"] = "application/x-www-form-urlencoded";

        let data = new FormData();
        data.append("grant_type", "authorization_code");
        data.append("client_id", "oauthagents");
        data.append("client_secret", ""); // keep this empty
        data.append("code_verifier", codeVerifier);
        data.append("redirect_uri", process.env.VUE_APP_AGENT_DOMAIN);
        data.append("code", code);

        return axios({
          method: "POST",
          url: process.env.VUE_APP_API + "/auth/oauth2.0/accessToken",
          data: data,
          headers: headers,
        });
      },
      refresh(refreshToken, clientId) {
        let headers = request.headers(false, false);
        headers["Content-Type"] = "application/x-www-form-urlencoded";

        let data = new FormData();
        data.append("grant_type", "refresh_token");
        data.append("client_id", clientId);
        data.append("client_secret", "secret");
        data.append("refresh_token", refreshToken);

        return axios({
          method: "POST",
          url: `${process.env.VUE_APP_API}/auth/oauth2.0/accessToken`,
          data: data,
          headers: headers,
        });
      },
      logout() {
        console.log("Here on logout");
        // let headers = request.headers(false, false);
        let headers = {
          Accept: "application/json",
          "Cache-control": "no-cache",
        };

        axios({
          method: "GET",
          url: process.env.VUE_APP_API + "/auth/logout",
          headers: headers,
        });
      },
    };
  },
};

export default auth;
